import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    getMvnoDashboard: [],
    loading: false,
    error: null,
}

const getMvnoDashboardSlice = createSlice({
    name: "getMvnoDashboard",
    initialState,
    reducers: {
        fetchGetMvnoDashboardSuccess: (state, action) => {
            state.loading = false;
            state.getMvnoDashboard = action.payload;
        },
        fetchGetMvnoDashboardFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const { fetchGetMvnoDashboardSuccess, fetchGetMvnoDashboardFailure } = getMvnoDashboardSlice.actions;

export default getMvnoDashboardSlice.reducer;
